import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {FrameworkHttpService} from '../framework/http/service';
import {ChasingPlanSettings, QARService} from '../services/qar.service';
import {AppUser, AppUserData} from '../framework/AppUser';
import {Chunker} from '../framework/chunker';

@Component({
	selector: 'app-page-config',
	templateUrl: 'config.html',
	providers: [QARService]
})
export class PageConfigComponent implements OnInit {
	public isAuditor = false;

	constructor(public api: QARService, public user: AppUser) {

	}

	ngOnInit(): void {
		this.isAuditor = this.user.hasGroup('AUDITORS');
		this.schedules_init();
		this.chasing_init();
		if (!this.isAuditor) {
			this.sodClash_init();
			this.rejection_init();
			this.others_init();
		}
	}

	length(w) {
		return w.length;
	}

	input_allowOnlyNumberChange(event) {
		let fail = false;
		try {
			const value = parseInt(event.target.value, 0);
			fail = value > 100 || value === 0;
		} catch (e) {
			fail = true;
		}

		if (fail) {
			event.target.value = 1;
		}
	}

	input_allowOnlyNumber(event) {
		const e = event as KeyboardEvent;
		console.log(e.keyCode, e.shiftKey);
		if (
			!(
				(e.shiftKey === true && e.keyCode >= 48 && e.keyCode <= 57)
			)
			&& (
				(e.shiftKey === false && e.keyCode >= 48 && e.keyCode <= 57) ||
				[46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl+A
				(e.keyCode === 65 && e.ctrlKey === true) ||
				// Allow: Ctrl+C
				(e.keyCode === 67 && e.ctrlKey === true) ||
				// Allow: Ctrl+V
				(e.keyCode === 86 && e.ctrlKey === true) ||
				// Allow: Ctrl+X
				(e.keyCode === 88 && e.ctrlKey === true) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39) ||
				// numpad
				(e.keyCode >= 97 && e.keyCode <= 105)
			)
		) {
			// let it happen, don't do anything
			let fail = false;
			try {
				const value = parseInt(event.target.value, 0);
				fail = value > 100 || value === 0;
			} catch (e) {
				fail = true;
			}

			if (fail) {
				event.target.value = 1;
				event.preventDefault();
				return false;
			}


			return;
		}
		event.preventDefault();
		event.target.value = 1;
		return false;

	}

	kindaValidEmail(w) {
		// console.log('kindaValidEmail', w, w.length, w.indexOf('@'));
		return w.length >= 12 && w.indexOf('@') !== -1;
	}

	public alert = {
		hidden: true,
		title: '',
		type: ''
	};

	alertDisplay(title, type = '') {
		this.alert.hidden = false;
		this.alert.title = title;
		this.alert.type = type;
	}

	//#region SCHEDULES
	public schedules = {
		date: null,
		sevenDaysAgo: new Date().setDate(new Date().getDate() - 7),
		reportType: null,
		saving: false,
		errorLoad: false,
		loading: false,
		chunkedData: [],
		chunker: new Chunker([]),
		tableHeaders: [
			{label: 'Report Type'},
			{label: 'Date'},
			{label: 'Action'},
		]
	};

	schedules_isFutureDate(d) {
		return new Date(Date.parse(d))
			>=
			new Date(new Date().setDate(new Date().getDate() - 1));
	}

	public schedules_init() {
		this.schedules.loading = true;
		this.schedules.errorLoad = false;
		this.api.retrieveSettingsReportSchedule().then(r => {
			this.schedules.loading = false;
			console.log('retrieveSettingsReportSchedule', r, r.length);
			this.schedules.chunker = new Chunker(r);
		}, e => {
			this.schedules.loading = false;
			this.schedules.errorLoad = true;
		});
	}

	public schedules_add() {
		const date = this.schedules.date;

		if (!date || new Date(date).getFullYear() >= new Date().getFullYear() + 2 || new Date(date).getFullYear() < new Date().getFullYear()) {
			this.alertDisplay('Please enter a date');
			return;
		}

		if (!this.schedules.reportType) {
			this.alertDisplay('Please select a report type');
			return;
		}

		console.log('schedules_add', date, this.schedules.reportType);
		this.schedules.loading = true;
		this.api.addSettingsReportSchedule(this.schedules.reportType, date).then(r => {
			this.schedules.loading = false;
			this.schedules_init();
			this.schedules.date = null;
			this.schedules.reportType = null;
		}, e => {
			this.schedules.loading = false;
			this.alertDisplay('Sorry, could not add, please check the date and select a type of report', 'error');
		});

	}

	public schedules_delete(id) {
		console.log('schedules_delete', id);
		this.schedules.loading = true;
		this.api.deleteSettingsReportSchedule(id).then(r => {
			this.schedules.loading = false;
			this.schedules_init();
		});
	}

	//#endregion

	//#region CHASING PLAN
	public chasing = {
		data: new ChasingPlanSettings(),
		errorLoad: false,
		loading: false,
		saving: false
	};

	public chasing_init() {
		this.chasing.loading = true;
		this.chasing.errorLoad = false;
		this.api.retrieveSettingsChasingPlan().then(r => {
			console.log('chasing data', r);
			this.chasing.loading = false;
			this.chasing.data = r;
		}, e => {
			console.error(e);
			this.chasing.loading = false;
			this.chasing.errorLoad = true;
		});
	}

	public chasing_save() {
		if (this.chasing.data.reminder3Active && !this.kindaValidEmail(this.chasing.data.reminderEmail)) {
			this.alertDisplay('Please enter a valid email', 'danger');
		} else {
			this.chasing.saving = true;
			this.api.saveSettingsChasingPlan(this.chasing.data).then(r => {
				this.chasing.saving = false;
				this.alertDisplay('Report Chasing Plan saved!', 'success');
			}, e => {
				if (e.status === 400) {
					this.alertDisplay('Please enter a valid email!', 'danger');
				} else {
					this.chasing.errorLoad = true;
				}
				this.chasing.saving = false;
			});
		}
	}

	//#endregion

	//#region !sodClash
	public rejection = {
		data: {
			newEmail: '',
			emails: []
		},
		dataSelected: [],
		errorLoad: false,
		error: false,
		loading: false,
		saving: false,
		validating: false,
		errorDuplicate: false
	};

	public rejection_init() {
		this.rejection.loading = true;
		this.rejection.errorLoad = false;
		this.api.retrieveSettingsRejection().then(r => {
			console.log('rejection data', r);
			this.rejection.loading = false;
			this.rejection.data.emails = r;
		}, e => {
			console.error(e);
			this.rejection.loading = false;
			this.rejection.errorLoad = true;
		});
	}


	public rejection_save() {
		return new Promise((ok, err) => {
			this.rejection.saving = true;
			console.log('rejection_save', this.rejection.data.emails);
			this.api.saveSettingsRejection(this.rejection.data.emails).then(r => {
				this.rejection.saving = false;
				this.alertDisplay('Rejection Reasons Notification - Email Distribution saved', 'success');
				ok([]);
			}, e => {
				console.error(e);
				if (e.status === 400) {
					this.alertDisplay('Please enter a valid email instead of "' + e.error + '"', 'danger');
				} else {
					this.alertDisplay('Sorry, could not save the Rejection Reasons - Notification Email Distribution, please refresh the page to try again', 'danger');
				}
				this.rejection.saving = false;
				err(e);
			});
		});
	}

	//#endregion


	//#region SOD Clash
	public sodClash = {
		data: {
			newEmail: '',
			emails: []
		},
		dataSelected: [],
		errorLoad: false,
		error: false,
		loading: false,
		saving: false,
		validating: false,
		errorDuplicate: false
	};

	public sodClash_init() {
		this.sodClash.loading = true;
		this.sodClash.errorLoad = false;
		this.api.retrieveSettingsSODClash().then(r => {
			console.log('sodClash data', r);
			this.sodClash.loading = false;
			this.sodClash.data.emails = r;
		}, e => {
			console.error(e);
			this.sodClash.loading = false;
			this.sodClash.errorLoad = true;
		});
	}

	public sodClash_save() {
		return new Promise((ok, err) => {
			this.sodClash.saving = true;
			this.api.saveSettingsSODClash(this.sodClash.data.emails).then(r => {
				this.sodClash.saving = false;
				this.alertDisplay('SOD Clash Report - Email distribution saved', 'success');
				ok([]);
			}, e => {
				console.error(e);
				if (e.status === 400) {
					this.alertDisplay('Please enter a valid email instead of "' + e.error + '"', 'danger');
				} else {
					this.alertDisplay('Sorry, could not save the sodClash Reasons - Notification Email Distribution, please refresh the page to try again', 'danger');
				}
				this.sodClash.saving = false;
				err(e);
			});
		});
	}


	//#endregion

	//#region others
	public others = {
		data: {},
		loading: false,
		errorLoading: false,
		saving: false
	};

	others_init() {
		this.others.loading = true;
		this.api.retrieveSettingsOthers().then(r => {
			this.others.loading = false;
			this.others.data = r;
		}, e => {
			this.others.loading = false;
			this.others.errorLoading = true;
		});
	}

	public others_save() {
		this.others.saving = true;
		this.api.saveSettingsOthers(this.others.data).then(r => {
			this.others.saving = false;
		}, e => {
			this.alertDisplay('Sorry, could not save the Others settings, please refresh the page to try again', 'danger');
			this.others.saving = false;
		});
	}

	//#endregion

	public helper_camelCaseToHuman(str) {
		// sbs / tc / lm
		str = str.replace('SBS', 'sbs').replace('TC', 'tc').replace('LM', 'lm').replace('PEGA', 'pega');
		const result = str.replace(/([A-Z])/g, ' $1');
		return result.charAt(0).toUpperCase() + result.slice(1);
	}
}
